<template>
  <beast-packages-list :url="packageUrl"
                       :package-search="false"
                       v-on:keywordSearch="updateSearch"/>
</template>

<style scoped lang="scss">
</style>

<script>
import BeastPackagesList from "../../components/packages/BeastPackagesList.vue";

export default {
  components: { BeastPackagesList },
  props: {
    org: Object
  },
  watch: {
    org() {
      this.updateUrl();
    }
  },
  data() {
    return {
      packageUrl: ``
    };
  },
  methods: {
    updateUrl() {
      if (this.org !== undefined && this.org !== null && this.org.slug !== "") {
        this.packageUrl = `/organizations/${this.org.slug}/packages`;
      }
    },
    updateSearch(query) {
      this.$emit("updateSearch", query);
    }
  },
  beforeMount() {
    this.updateUrl();
  }
};
</script>
